import Theme from 'Theme';
import { Device } from 'DeviceUtils';

export const textCommon = {
    fontFamily: Theme.regularFont,
    textAlign: 'center'
};

export const linkCommon = {
    color: Theme.primaryLinkColor,
    textDecorationColor: Theme.primaryLinkColor
};

const dialogCommon = {
    window: {
        backgroundColor: 'rgba(0, 0, 0, 0.95)',
        height: '100%',
        alignItems: 'center',
        justifyContent: 'center',
        paddingHorizontal: Device.isTabletOrWeb ? '20%' : Theme.primaryMargin
    },
    closeIcon: {
        position: 'absolute',
        top: Theme.BU * 2,
        right: Theme.BU,
        display: 'none'
    },
    title: {
        ...textCommon,
        fontSize: Theme.fontSizes.title,
        color: Theme.primaryTextColor,
        marginBottom: 12
    },
    line: {
        height: 2,
        width: '100%',
        backgroundColor: '#4C4D4E'
    },
    whiteText: {
        ...textCommon,
        fontSize: Theme.primaryFontSize,
        color: Theme.primaryTextColor,
        paddingVertical: 12,
        width: Device.isTabletOrWeb ? 500 : 300
    },
    greyText: {
        ...textCommon,
        fontSize: Theme.fontSizes.description,
        color: Theme.secondaryTextColor,
        marginVertical: 24
    },
    button: {
        minWidth: 100,
        marginTop: 25,
        maxWidth: 200,
        alignSelf: 'center'
    },
    buttonsConteiner: {
        justifyContent: 'center'
    }
};

if (Device.isTabletOrWeb) {
    dialogCommon.window.paddingHorizontal = '20%';
}

export default dialogCommon;
